import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CustomFieldsPage.NetSuiteCustomFields', {
    documentTitle: 'Fields | {companyName}',
    addLine: 'Add line',
    tabName: 'NetSuite',
    bodyFieldsSectionHeader: 'Transaction body fields',
    lineFieldsSectionHeader: 'Transaction line fields',
    segmentFieldsSectionHeader: 'Custom segments',
    nsFieldNameCol: 'Field Name',
    nsFieldNamePlaceholder: 'Select field',
    fieldLevelCol: 'Field Level',
    fieldLevelColPlaceholder: 'Select level',
    fieldInternalIdCol: 'Field Internal Id',
    fieldScriptIdCol: 'Field Script Id',
    referenceRecordTypeCol: 'Reference Record Type',
    fieldTypeCol: 'Field Type',
    vendorBillWorkflowCol: 'Vendor Bill workflow',
    poWorkflowCol: 'Purchase Order workflow',
    expenseReportsWorkflowCol: 'Expense Report workflow',
    salesOrderWorkflowCol: 'Sales Order workflow',
    vraWorkflowCol: 'VRA workflow',
    raWorkflowCol: 'RA workflow',
    billPaymentWorkflowCol: 'Bill Payment workflow',
    invoiceWorkflowCol: 'Invoice workflow',
    journalEntryWorkflowCol: 'Journal Entry workflow',
    vendorWorkflowCol: 'Vendor workflow',
    publishChangesBtnText: 'Publish changes',
    updateSuccessText: 'Fields have been saved',
    mandatoryFieldsError: 'Please fill in all mandatory fields.',
    usedInMatrixError:
        'Field {fieldName} cannot be removed or disabled because it is being used in the approval workflows [{workflowList}]',
});
